import React from 'react';

import { SVGIcon } from '@uikit/old/Icon/Icon';
import { WARNING_COLOR } from '@constants/colors';

import './InsertionBrief.scss';

type InsertionBriefPropsType = {
  /** The Google Doc brief. Rendered only when non-empty. */
  url: string;
  title: string;
  hint: string;
  linkLabel: string;
  /** Tighter padding for inline table cells and side panels. */
  compact?: boolean;
};

/**
 * An instruction card pointing at the Google Doc brief of a link insertion
 * (RES-7286). Shared by the Publisher portal (where the brief says where in
 * the publisher's article the link goes) and the Concierge client portal
 * (where it tells the client which article their link will be placed in).
 * Realm-specific copy comes in through props.
 */
function InsertionBrief({
  url,
  title,
  hint,
  linkLabel,
  compact = false,
}: InsertionBriefPropsType): JSX.Element {
  if (!url) {
    return null;
  }

  return (
    <div className={`insertion-brief${compact ? ' insertion-brief--compact' : ''}`}>
      <div className="insertion-brief__title">
        <SVGIcon icon="documentIcon" size={14} color={WARNING_COLOR} />
        {title}
      </div>
      <p className="insertion-brief__hint">{hint}</p>
      <a
        className="insertion-brief__link"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        title={url}
      >
        {linkLabel}
        <SVGIcon icon="externalLink" size={12} />
      </a>
    </div>
  );
}

export default InsertionBrief;
